import { Button } from '@/components/ui/button'
import { Section } from '@/components/ui/section'
import { Text } from '@/components/ui/text'
import { EXTERNAL_LINKS } from '@/constants/external-link'
import { CommonOrbit, CommonWallet } from '@/icons'
import { useTradePersistStore, useWalletModalActions } from '@/store'

import { useTranslation } from 'react-i18next'

export const ConnectWallet = () => {
  const { t } = useTranslation()
  const { setShowWalletModal } = useWalletModalActions()
  const token = useTradePersistStore((state) => state.fromToken)
  return (
    <div className='flex-1 flex items-center justify-center min-h-[calc(100vh-8.5rem)]'>
      <Section className='p-8 md:p-8 text-center w-[504px] mx-auto flex flex-col gap-4 items-center -translate-y-9'>
        <div className='rounded-sm w-10 h-10 bg-main-12 flex items-center justify-center ring-[1px] md:ring-[0.5px] [@media(max-resolution:1.9dppx)]:ring-[1px] ring-main-100'>
          <CommonOrbit className='size-7 text-main-100' />
        </div>
        <Text as='p' size={28}>
          {t('title.REFERRAL_HUB')}
        </Text>
        <div>
          <Text as='p' color='white-48'>
            {t('title.REFERRAL_PROGRAM_DETAILS')}
          </Text>
          <Text
            as='a'
            href={EXTERNAL_LINKS.REFERRAL_PROGRAM_DETAILS}
            target='_blank'
            color='main'
            className='underline'
          >
            {t('title.REFERRAL_PROGRAM_DETAILS_LINK')}
          </Text>
        </div>
        <Button size='lg' onClick={() => setShowWalletModal({ show: true, token })}>
          <CommonWallet className='size-6' />
          {t('button.CONNECT_WALLET')}
        </Button>
      </Section>
    </div>
  )
}
